import { useState } from 'react';
import { Link } from 'react-router-dom';
import MobileTranslationBtn from '../../components/MobileTranslationBtn/MobileTranslationBtn';

import './MobileMenu.scss';

function MobileMenu(props) {
    const [isOpened, setIsOpened] = useState(false);

    function handleClick() {
        setIsOpened(prevState => !prevState);
    }

    return (
        <>
            <button className='burger-btn' onClick={handleClick}>
                <hr className={ isOpened ? 'first line X' : 'first line' }/>
                <hr className={ isOpened ? 'second line X' : 'second line' }/>
                <hr className={ isOpened ? 'last line X' : 'last line' }/>
            </button>
            <nav className={isOpened ? 'side-bar open' : 'side-bar closed'} >
                <Link to='/' className='side-bar-link' onClick={() => setIsOpened(false)} >{ props.title1 }</Link>
                <Link to='/sobre' className='side-bar-link' onClick={() => setIsOpened(false)} >{ props.title2 }</Link>
                <Link to='/contatos' className='side-bar-link' onClick={() => setIsOpened(false)} >{ props.title3 }</Link>
                <MobileTranslationBtn />
            </nav>
            
        </>
    )
}

export default MobileMenu;
